const EMPTY_SUMMARY = {
    needsAttention: [],
    recentActivity: []
};
export function useClientSummary(_clientId) {
    return {
        summary: EMPTY_SUMMARY,
        isLoading: false
    };
}
